import React from 'react';

const Y2026 = [
  [
    'How to Win Friends & Influence People',
    'https://www.goodreads.com/book/show/4865.How_to_Win_Friends_Influence_People',
    3,
  ],
  ['Metal Slug: The Ultimate History', 'https://www.goodreads.com/review/show/8543892960', 3],
  [
    'The Inner Game of Tennis: The Classic Guide to the Mental Side of Peak Performance',
    'https://www.goodreads.com/book/show/905.The_Inner_Game_of_Tennis',
    5,
  ],
  ['不被大风吹倒', 'https://www.goodreads.com/book/show/222540865', 3],
  ['倦怠社会', 'https://www.goodreads.com/review/show/8671627828', 2],
];

const Y2025 = [
  [
    'The Power of Language: How the Codes We Use to Think, Speak, and Live Transform Our Minds',
    'https://www.goodreads.com/book/show/61606704-the-power-of-language',
    3,
  ],
  [
    'Efficient Linux at the Command Line',
    'https://www.goodreads.com/book/show/59841860-efficient-linux-at-the-command-line',
    2,
  ],
  ['认识建筑：丰子恺建筑六讲', 'https://www.goodreads.com/book/show/60791270', 2],
  [
    'Making Up the Mind: How the Brain Creates Our Mental World',
    'https://www.goodreads.com/book/show/16901339-making-up-the-mind',
    4,
  ],
  [
    'The Fundamentals of Ethics',
    'https://www.goodreads.com/book/show/7601604-the-fundamentals-of-ethics',
    3,
  ],
  [
    'San Fransicko: Why Progressives Ruin Cities',
    'https://www.goodreads.com/book/show/56645981-san-fransicko',
    3,
  ],
  ['当我谈跑步时，我谈些什么', 'https://www.goodreads.com/book/show/20758207', 3],
  [
    'Supercommunicators: How to Unlock the Secret Language of Connection',
    'https://www.goodreads.com/book/show/157981748-supercommunicators',
    3,
  ],
  [
    'Machine Learning System Design Interview',
    'https://www.goodreads.com/book/show/120532868-machine-learning-system-design-interview',
    3,
  ],
  [
    'Command Line Applications in Rust',
    'https://www.goodreads.com/book/show/60780056-command-line-applications-in-rust',
    3,
  ],
  [
    'The Rust Programming Language',
    'https://www.goodreads.com/book/show/25008661-the-rust-programming-language',
    4,
  ],
  [
    '5 Types of People Who Can Ruin Your Life: Identifying and Dealing with Narcissists, Sociopaths, and Other High-Conflict Personalities',
    'https://www.goodreads.com/book/show/35133298-5-types-of-people-who-can-ruin-your-life',
    2,
  ],
  [
    'BART: The Dramatic History of the Bay Area Rapid Transit System',
    'https://www.goodreads.com/book/show/30102484-bart',
    2,
  ],
  [
    'Programming Rust: Fast, Safe Systems Development',
    'https://www.goodreads.com/book/show/25550614-programming-rust',
    4,
  ],
  [
    'Outlive: The Science & Art of Longevity',
    'https://www.goodreads.com/book/show/61153739-outlive',
    3,
  ],
  [
    "The New Dad's Survival Guide: What to Expect in the First Year and Beyond",
    'https://www.goodreads.com/book/show/18460069-the-new-dad-s-survival-guide',
    3,
  ],
  [
    'Being Mortal: Medicine and What Matters in the End',
    'https://www.goodreads.com/book/show/20696006-being-mortal',
    3,
  ],
  [
    'Incognito: The Secret Lives of the Brain',
    'https://www.goodreads.com/book/show/9536930-incognito',
    3,
  ],
  [
    'AI Engineering: Building Applications with Foundation Models',
    'https://www.goodreads.com/book/show/216848047-ai-engineering',
    4,
  ],
];

const Y2024 = [
  [
    'The Art of Doing Science and Engineering: Learning to Learn',
    'https://www.goodreads.com/book/show/530415.The_Art_of_Doing_Science_and_Engineering',
    1,
  ],
  [
    'Refactoring: Improving the Design of Existing Code',
    'https://www.goodreads.com/book/show/44936.Refactoring',
    3,
  ],
  ['中國是怎麼形成的：大歷史的速寫', 'https://www.goodreads.com/book/show/202469587', 2],
  [
    'The Cartoon Introduction to Economics: Macroeconomics Vol Two',
    'https://www.goodreads.com/book/show/131901938-the-cartoon-introduction-to-economics',
    2,
  ],
  ['The Plague', 'https://www.goodreads.com/book/show/11989.The_Plague', 2],
  [
    'Tidy First?: A Personal Exercise in Empirical Software Design',
    'https://www.goodreads.com/book/show/171691901-tidy-first',
    4,
  ],
  [
    'The Book of CP-System',
    'https://www.goodreads.com/book/show/75274379-the-book-of-cp-system',
    5,
  ],
  [
    'Four Thousand Weeks: Time Management for Mortals',
    'https://www.goodreads.com/book/show/54785515-four-thousand-weeks',
    2,
  ],
  [
    'The Node Craftsman Book',
    'https://www.goodreads.com/book/show/18633684-the-node-craftsman-book',
    2,
  ],
  ['中国文化中的饮食', 'https://www.goodreads.com/book/show/1895190.Food_in_Chinese_Culture', 2],
  [
    'Understanding Distributed Systems',
    'https://www.goodreads.com/book/show/121101522-understanding-distributed-systems-2nd-edition-paperback',
    4,
  ],
  [
    'The Simplest Baby Book in the World',
    'https://www.goodreads.com/book/show/58746568-the-simplest-baby-book-in-the-world',
    3,
  ],
  [
    '有数：普通人的数字生活纪实',
    'https://www.goodreads.com/book/show/95657738-tech-for-good-how-ordinaries-ride-the-wave-of-digitalization-in-china',
    3,
  ],
  [
    'Mindset: The New Psychology of Success',
    'https://www.goodreads.com/book/show/40745.Mindset',
    3,
  ],
  [
    "Chip War: The Fight for the World's Most Critical Technology",
    'https://www.goodreads.com/book/show/60321447-chip-war',
    3,
  ],
  [
    'The Psychology of Money',
    'https://www.goodreads.com/book/show/41881472-the-psychology-of-money',
    3,
  ],
  [
    'Code: The Hidden Language of Computer Hardware and Software',
    'https://www.goodreads.com/book/show/44882.Code',
    5,
  ],
  ['饱食穷民', 'https://www.goodreads.com/book/show/52214503', 3],
  [
    'Secrets of the JavaScript Ninja',
    'https://www.goodreads.com/book/show/58354979-secrets-of-the-javascript-ninja',
    3,
  ],
  [
    'Super Study Guide: Transformers & Large Language Models',
    'https://www.goodreads.com/book/show/217141763-super-study-guide',
    3,
  ],
  [
    'How Will You Measure Your Life?',
    'https://www.goodreads.com/book/show/13425570-how-will-you-measure-your-life',
    3,
  ],
  [
    'Software Design X-Rays: Fix Technical Debt with Behavioral Code Analysis',
    'https://www.goodreads.com/book/show/36517037-software-design-x-rays',
    3,
  ],
  [
    'China After Mao: The Rise of a Superpower',
    'https://www.goodreads.com/book/show/60070311-china-after-mao',
    3,
  ],
  [
    'Observability Engineering: Achieving Production Excellence',
    'https://www.goodreads.com/book/show/59039072-observability-engineering',
    2,
  ],
  [
    'A Philosophy of Software Design',
    'https://www.goodreads.com/book/show/39996759-a-philosophy-of-software-design',
    3,
  ],
  [
    'Antifragile: Things That Gain from Disorder',
    'https://www.goodreads.com/book/show/13530973-antifragile',
    2,
  ],
  [
    "We're Pregnant! The First Time Dad's Pregnancy Handbook (First-Time Dads)",
    'https://www.goodreads.com/book/show/39712773-we-re-pregnant-the-first-time-dad-s-pregnancy-handbook',
    3,
  ],
  ['城のつくり方図典', 'https://www.goodreads.com/book/show/25988364', 4],
];

const Y2023 = [
  [
    'Amp It Up: Leading for Hypergrowth by Raising Expectations, Increasing Urgency, and Elevating Intensity',
    'https://www.goodreads.com/book/show/59383944-amp-it-up',
    2,
  ],
  [
    'Staff Engineer: Leadership Beyond the Management Track',
    'https://www.goodreads.com/book/show/56481725-staff-engineer',
    4,
  ],
  [
    "Works Well with Others: An Outsider's Guide to Shaking Hands, Shutting Up, Handling Jerks, and Other Crucial Skills in Business That No One Ever Teaches You",
    'https://www.goodreads.com/book/show/24612116-works-well-with-others',
    3,
  ],
  [
    'Accelerate: Building and Scaling High Performing Technology Organizations',
    'https://www.goodreads.com/book/show/35747076-accelerate',
    2,
  ],
  ['Eloquent JavaScript', 'https://www.goodreads.com/book/show/39866497-eloquent-javascript', 4],
  [
    'Traction: A Startup Guide to Getting Customers',
    'https://www.goodreads.com/book/show/22091581-traction',
    4,
  ],
  ['低端人口', 'https://www.goodreads.com/book/show/40124601', 3],
  ['白狗秋千架', 'https://www.goodreads.com/book/show/17250076-bai-gou-qiu-qian-jia', 4],
  [
    'Build: An Unorthodox Guide to Making Things Worth Making',
    'https://www.goodreads.com/book/show/59696349-build',
    4,
  ],
  [
    'Breath: The New Science of a Lost Art',
    'https://www.goodreads.com/book/show/48890486-breath',
    3,
  ],
  [
    'Atomic Habits: An Easy & Proven Way to Build Good Habits & Break Bad Ones',
    'https://www.goodreads.com/book/show/40121378-atomic-habits',
    3,
  ],
  [
    'The Courage to Be Disliked: How to Free Yourself, Change your Life and Achieve Real Happiness',
    'https://www.goodreads.com/book/show/43306206-the-courage-to-be-disliked',
    3,
  ],
  ['寻味东西：扶霞美食随笔集', 'https://www.goodreads.com/book/show/60737594', 3],
  [
    'Working in Public: The Making and Maintenance of Open Source Software',
    'https://www.goodreads.com/book/show/54140556-working-in-public',
    3,
  ],
  [
    'Universal Principles of UX',
    'https://www.goodreads.com/book/show/61398962-universal-principles-of-ux',
    3,
  ],
  [
    'Blood and Silk: Power and Conflict in Modern Southeast Asia',
    'https://www.goodreads.com/book/show/35377459-blood-and-silk',
    4,
  ],
  [
    '沖繩戰的孩子們: 太平洋戰爭下少年少女成為士兵之路',
    'https://www.goodreads.com/book/show/199432909',
    3,
  ],
  [
    'Cartoon Introduction to Economics, Volume I: Microeconomics',
    'https://www.goodreads.com/book/show/7333109-cartoon-introduction-to-economics-volume-i',
    3,
  ],
  [
    'Effective TypeScript: 62 Specific Ways to Improve Your TypeScript',
    'https://www.goodreads.com/book/show/48570456-effective-typescript',
    4,
  ],
  [
    "The Staff Engineer's Path: A Guide for Individual Contributors Navigating Growth and Change",
    'https://www.goodreads.com/book/show/61058107-the-staff-engineer-s-path',
    4,
  ],
  ['AWS Cookbook', 'https://www.goodreads.com/book/show/58230360-aws-cookbook', 3],
  ['中国历代政治得失', 'https://www.goodreads.com/book/show/20567233', 3],
  [
    'Talking to Strangers: What We Should Know About the People We Don’t Know',
    'https://www.goodreads.com/book/show/43848929-talking-to-strangers',
    3,
  ],
  [
    'Read People Like a Book: How to Analyze, Understand, and Predict People’s Emotions, Thoughts, Intentions, and Behaviors',
    'https://www.goodreads.com/book/show/56199402-read-people-like-a-book',
    1,
  ],
  ['古代汉语常识', 'https://www.goodreads.com/book/show/34394966', 5],
  ['汉语音韵学常识', 'https://www.goodreads.com/book/show/91677673', 4],
];

const Y2022 = [
  [
    'What If? 2: Additional Serious Scientific Answers to Absurd Hypothetical Questions',
    'https://www.goodreads.com/book/show/60190659-what-if-2',
    1,
  ],
  ['Who: The A Method for Hiring', 'https://www.goodreads.com/book/show/4989687-who', 1],
  [
    'The King of Fighters: the Ultimate History',
    'https://www.goodreads.com/book/show/61250722-the-king-of-fighters',
    4,
  ],
  ['北美華人創業訪談實錄', 'https://www.goodreads.com/book/show/63103817', 3],
  [
    'Buy This, Not That: How to Spend Your Way to Wealth and Freedom',
    'https://www.goodreads.com/book/show/59149045-buy-this-not-that',
    4,
  ],
  [
    'Super Founders: What Data Reveals About Billion-Dollar Startups',
    'https://www.goodreads.com/book/show/55277918-super-founders',
    4,
  ],
  [
    'Designing Data-Intensive Applications',
    'https://www.goodreads.com/book/show/23463279-designing-data-intensive-applications',
    5,
  ],
  [
    "100 Deadly Skills: The SEAL Operative's Guide to Eluding Pursuers, Evading Capture, and Surviving Any Dangerous Situation",
    'https://www.goodreads.com/book/show/25111028-100-deadly-skills',
    2,
  ],
  ['垃圾回收算法与实现', 'https://www.goodreads.com/book/show/56047497', 3],
  ['失落的卫星：深入中亚大陆的旅程', 'https://www.goodreads.com/book/show/54760626', 5],
  [
    'Never Split the Difference: Negotiating As If Your Life Depended On It',
    'https://www.goodreads.com/book/show/26156469-never-split-the-difference',
    4,
  ],
  ['日本未来时', 'https://www.goodreads.com/book/show/56525614', 2],
  [
    'Understanding Movies',
    'https://www.goodreads.com/book/show/488428.Understanding_Movies_11th_Edition',
    5,
  ],
  [
    'Crafting Interpreters',
    'https://www.goodreads.com/book/show/58661468-crafting-interpreters',
    3,
  ],
];

const Y2021 = [
  ['Mercurial: The Definitive Guide', 'https://www.goodreads.com/book/show/6636216-mercurial', 2],
  [
    'Effective Python: 90 Specific Ways to Write Better Python',
    'https://www.goodreads.com/book/show/48566725-effective-python',
    2,
  ],
  [
    'The TypeScript Handbook',
    'https://www.goodreads.com/book/show/35954871-typescript-handbook',
    2,
  ],
  [
    "You Kant Make it Up!: Strange Ideas from History's Great Philosophers",
    'https://www.goodreads.com/book/show/12510381-you-kant-make-it-up',
    3,
  ],
  [
    'Logicomix: An Epic Search for Truth',
    'https://www.goodreads.com/book/show/6493321-logicomix',
    3,
  ],
  [
    'Range: Why Generalists Triumph in a Specialized World',
    'https://www.goodreads.com/book/show/41795733-range',
    1,
  ],
  ['从大都到上都：在古道上重新发现中国', 'https://www.goodreads.com/book/show/53287831', 4],
  [
    'The Coding Career Handbook',
    'https://www.goodreads.com/book/show/54375336-the-coding-career-handbook-guides-principles-strategies-and-tactics',
    5,
  ],
  [
    'Software Engineering at Google: Lessons Learned from Programming Over Time',
    'https://www.goodreads.com/book/show/48816586-software-engineering-at-google',
    3,
  ],
  ['Web Browser Engineering', 'https://browser.engineering/', 2],
  ['会走路的钱', 'https://www.goodreads.com/book/show/50914465-money-walks', 5],
];

const Y2020 = [
  ['From Ramen to Riches', 'https://www.goodreads.com/book/show/11689892-from-ramen-to-riches', 2],
  ['动物凶猛', 'https://www.goodreads.com/book/show/23810865', 5],
  ['哲学家都干了什么', 'https://www.goodreads.com/book/show/18663932', 4],
  ['中东死生门', 'https://www.goodreads.com/book/show/36622302', 4],
  ['音乐入门：丰子恺音乐五讲', 'https://www.goodreads.com/book/show/53358554', 3],
  ['棋王树王孩子王', 'https://www.goodreads.com/book/show/16098905', 4],
  ['尸人庄杀人事件', 'https://www.goodreads.com/book/show/48662547', 3],
  ['常识与通识', 'https://www.goodreads.com/book/show/36228073', 4],
  ['至味在人间', 'https://www.goodreads.com/book/show/28603774', 3],
  ['丰子恺艺术四书', 'https://www.goodreads.com/book/show/38733596', 3],
  ['Linux Server Hacks', 'https://www.goodreads.com/book/show/86607.Linux_Server_Hacks', 3],
  [
    'More programming pearls',
    'https://www.goodreads.com/book/show/128600.More_Programming_Pearls',
    2,
  ],
  [
    'The Coaching Habit: Say Less, Ask More & Change the Way You Lead Forever',
    'https://www.goodreads.com/book/show/29342515-the-coaching-habit',
    2,
  ],
  [
    'Being Logical: A Guide to Good Thinking',
    'https://www.goodreads.com/book/show/721564.Being_Logical',
    3,
  ],
  [
    'The Making of Prince of Persia: Journals 1985-1993',
    'https://www.goodreads.com/book/show/52824295-the-making-of-prince-of-persia',
    2,
  ],
  [
    '1453: The Holy War for Constantinople and the Clash of Islam and the West',
    'https://www.goodreads.com/book/show/227354.1453',
    5,
  ],
  [
    '清明上河图：北宋繁华记忆',
    'https://www.goodreads.com/book/show/36054978-riverside-scene-at-qingming-festival',
    4,
  ],
  ['悠悠哉哉', 'https://www.goodreads.com/book/show/41104619', 4],
];

const Y2019 = [
  [
    '"What Do You Care What Other People Think?": Further Adventures of a Curious Character',
    'https://www.goodreads.com/book/show/35167718-what-do-you-care-what-other-people-think',
    4,
  ],
  ['鱼翅与花椒', 'https://www.goodreads.com/book/show/44536316', 4],
  [
    'Thing Explainer: Complicated Stuff in Simple Words',
    'https://www.goodreads.com/book/show/25329850-thing-explainer',
    4,
  ],
  ['癌症·新知/癌症·真相', 'https://www.goodreads.com/book/show/36690548-2', 4],
  ['余生皆假期', 'https://www.goodreads.com/book/show/27252565', 2],
  [
    'Sapiens: A Brief History of Humankind',
    'https://www.goodreads.com/book/show/23692271-sapiens',
    4,
  ],
  ['硅谷之谜', 'https://www.goodreads.com/book/show/32302070', 1],
  ['Homo Deus: A History of Tomorrow', 'https://www.goodreads.com/book/show/31138556-homo-deus', 3],
  [
    'The Great Game: The Emergence of Wall Street as a World Power: 1653-2000',
    'https://www.goodreads.com/book/show/939352.The_Great_Game',
    3,
  ],
  [
    '21 Lessons for the 21st Century',
    'https://www.goodreads.com/book/show/38820046-21-lessons-for-the-21st-century',
    3,
  ],
  ['北京折叠', 'https://goodreads.com/book/show/31838014', 3],
  [
    'What If? Serious Scientific Answers to Absurd Hypothetical Questions',
    'https://www.goodreads.com/book/show/21413662-what-if-serious-scientific-answers-to-absurd-hypothetical-questions',
    3,
  ],
  ['日本人的活法', 'https://www.goodreads.com/book/show/36195607-the-japanese-s-way-of-living', 1],
  [
    'Spy the Lie: Former CIA Officers Teach You How to Detect Deception',
    'https://www.goodreads.com/book/show/13167156-spy-the-lie',
    2,
  ],
  ['男人这东西', 'https://www.goodreads.com/book/show/13574995', 3],
  [
    'The Effective Engineer: How to Leverage Your Efforts In Software Engineering to Make a Disproportionate and Meaningful Impact',
    'https://www.goodreads.com/book/show/25238425-the-effective-engineer',
    3,
  ],
  ['和食古早味', 'https://www.goodreads.com/book/show/46021328', 3],
];

function getStarsComponent(n) {
  let stars = ['☆', '☆', '☆', '☆', '☆'];
  for (let i = 0; i < n; ++i) {
    stars[i] = '★';
  }

  return <a>{stars.join('')}</a>;
}

function getBookListComponent(yearList) {
  const res = [];
  // Sort the list first based on the stars, then on the titles.
  yearList.sort((a, b) => (b[2] === a[2] ? a[0].localeCompare(b[0]) : b[2] - a[2]));

  for (const item of yearList) {
    res.push(
      <li key={item[1]}>
        <span className="prefix">{getStarsComponent(item[2])}</span>
        <span className="content">
          <a href={item[1]}>{item[0]}</a>
        </span>
      </li>,
    );
  }
  return <ul class="stars">{res}</ul>;
}

/**
 * List rendering 2, drop it here just in case...
 */
/*
function getBookList(year) {
  const res = [];
  const booksByStars = {
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
  };
  for (const elem of year) {
    booksByStars[elem[2]].push(elem);
  }
  for (let i = 5; i > 0; --i) {
    res.push(<h3 class="stars">{renderStars(i)}</h3>);
    const bookList = booksByStars[i];
    if (bookList.length === 0) {
      res.push(<p>n/a</p>);
      continue;
    }
    const bookListComponent = [];
    for (const item of bookList) {
      bookListComponent.push(
        <li key={item[1]}>
          <a href={item[1]}>{item[0]}</a>
        </li>,
      );
    }
    res.push(<ul class="dashed">{bookListComponent}</ul>);
  }

  return res;
}
*/

const Books = () => {
  return (
    <div>
      <p>
        full list <a href="https://www.goodreads.com/user/show/18664085-bowei-zhang">here</a>.
      </p>
      <div>
        <ul class="stars">
          <li>
            <span className="prefix">★★★★★ =</span>
            <span className="content">the juice! would love to read it again.</span>
          </li>
          <li>
            <span className="prefix">★★★★☆ =</span>
            <span className="content">pog! time well spent.</span>
          </li>
          <li>
            <span className="prefix">★★★☆☆ =</span>
            <span className="content">decent dopamine boost achieved.</span>
          </li>
          <li>
            <span className="prefix">★★☆☆☆ =</span>
            <span className="content">
              enjoyed bits, but lowkey feel i could've done something else.
            </span>
          </li>
          <li>
            <span className="prefix">★☆☆☆☆ =</span>
            <span className="content">total waste of time.</span>
          </li>
        </ul>
      </div>
      <h3>2026</h3>
      {getBookListComponent(Y2026)}
      <h3>2025</h3>
      {getBookListComponent(Y2025)}
      <h3>2024</h3>
      {getBookListComponent(Y2024)}
      <h3>2023</h3>
      {getBookListComponent(Y2023)}
      <h3>2022</h3>
      {getBookListComponent(Y2022)}
      <h3>2021</h3>
      {getBookListComponent(Y2021)}
      <h3>2020</h3>
      {getBookListComponent(Y2020)}
      <h3>2019</h3>
      {getBookListComponent(Y2019)}
    </div>
  );
};

export default Books;
